<template>
  <div class="calculator calculator calculator--small">
    <div class="calculator__form calculator__form--active" v-if="!showPrice">
      <div class="calculator__group">
        <div class="calculator__group-data">
          <div class="calculator__input-group calculator__input-group--first">
            <label
              for="zipcode"
              class="calculator__input-group--label"
              v-bind:class="{'calculator__input-group--label-animated': animateZipcodeLabel}"
            >{{form.zipcodePlaceHolder}}</label>
            <input
              class="calculator__input calculator__input--text zipcode-text"
              type="text"
              maxlength="5"
              v-model="zipcode"
              id="zipcode"
              v-on:blur="handleZipcodeBlur"
              v-on:focus="handleZipcodeFocus"
              v-on:keyup.enter="submit($event)"
              v-bind:class="{'calculator__input--error': zipcodeHasError && !showInfo }"
            />
            <div
              v-if="zipcodeHasError"
              class="calculator__error zipcode-error calculator__error--active"
             v-bind:class="{'calculator__error--info':showInfo}"
            >
              <span v-html="zipcodeErrorMsg"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="calculator__group">
        <div class="calculator__group-data">
          <div class="calculator__input-group calculator__input-group--consumption">
            <div class="calculator__headline">{{form.consumption}}</div>
            <div style="position:relative;">
              <input
                class="calculator__input calculator__input--text"
                type="text"
                v-model="consumption"
                maxlength="6"
                v-bind:class="{'calculator__input--error': consumptionHasError}"
                v-on:focus="handleConsumptionFocus"
                v-on:keyup.enter="submit($event)"
              />
              <div
                v-if="consumptionHasError"
                class="calculator__error comsumption-error calculator__error--active"
              >
                <span v-html="consumptionErrorMsg"></span>
              </div>
              <span class="calculator__input-add">{{form.kwh}}</span>
            </div>

            <span class="calculator__input--hint">{{form.hint}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="calculator__buttons--full" v-if="!showPrice">
      <a class="button button--primary button--gradient" href="#" v-on:click="submit($event)">{{form.calculate}}</a>
    </div>

    <div class="calculator__result calculator__result--active" v-if="showPrice">
      <div class="calculator__result-data">
        <div class="calculator__result__price calculator__result__price--red">
          <span v-html="product.name"></span>
        </div>
        <div class="calculator__result__price">{{product.totalCost }} {{form.currency}}</div>
        <div class="calculator__result__price-text">
          <span v-html="form.flatText"></span>
        </div>
      </div>
      <div class="calculator__result-data calculator__result-data-buttons">
        <input
          type="button"
          class="button  button--green calculator__button"
          v-on:click="reset"
          v-bind:value="form.recalcualte"
        />
        <a
          class="button button--gradient calculator__button"
          v-bind:href="product.orderLink"
        >{{form.order}}</a>
      </div>
    </div>
  </div>
</template>


<script >
import { validateZipcodeService } from "../../services/ValidationService.js";
import { getProductsService } from "../../services/ProductsService.js";
import UrlService from "../../../../tpl-frontend/src/js/services/url.js";
import $ from "jquery";

const INIT_GAS_VALUE = 12136;

const CONSUMPTION_QUERYSTRING = "verbrauch";
const ZIPCODE_QUERYSTRING = "plz";

import config from "../../resources/Config.js";

export default {
  name: "FlatGas",
  props: [],
  data() {
    return {
      product: {},
      form: {},
      consumption: "",
      zipcode: "",
      zipcodeErrorMsg: "",
      showPrice: false,
      zipcodeHasError: false,
      consumptionHasError: false,
      consumptionErrorMsg: "",
      zipcodeFocused: false,
      showInfo: false,
      atleastOneQueryParameter:
        UrlService.parameterExist(CONSUMPTION_QUERYSTRING) ||
        UrlService.parameterExist(ZIPCODE_QUERYSTRING),
      allQueryParameters:
        UrlService.parameterExist(CONSUMPTION_QUERYSTRING) &&
        UrlService.parameterExist(ZIPCODE_QUERYSTRING)
    };
  },
  mounted() {
    this.form = config.flatgas.form;
    this.consumption = INIT_GAS_VALUE;

    const cookieObj = this.getCookies(config.flatgas.cookieName);
    if (cookieObj) {
      this.zipcode = cookieObj.zipcode;
      this.consumption = cookieObj.consumption;
    }

    if (UrlService.parameterExist(CONSUMPTION_QUERYSTRING)) {
      this.consumption = UrlService.getUrlParameter(
        CONSUMPTION_QUERYSTRING,
        this.consumption
      );
    }

    if (UrlService.parameterExist(ZIPCODE_QUERYSTRING)) {
      this.zipcode = UrlService.getUrlParameter(
        ZIPCODE_QUERYSTRING,
        this.zipcode
      );
    }

    if (this.atleastOneQueryParameter) {
      this.setCookies(config.flatgas.cookieName);
    }

    if (cookieObj || this.allQueryParameters) {
      this.calculate();
    }
  },
  computed: {
    animateZipcodeLabel() {
      return this.zipcode || this.zipcodeFocused;
    }
  },
  methods: {
    async submit($event){
      $event.preventDefault();
      await this.calculate();
    },
    async calculate() {
      this.reset();
      const isValid = await this.validate();
      if (!isValid) {
        return;
      }
      const productServiceResponse = await this.getProducts();   
      if (productServiceResponse.error) {     
          this.showInfo =
          productServiceResponse.error.errorCode == config.flatgas.code.zipcodeNotAvailableHint ||
         productServiceResponse.error.errorCode == config.flatgas.code.zipcodeOutOfRangeHint;
        productServiceResponse.error.code == config.flatgas.code.consumption
          ? this.setConsumptionError(productServiceResponse.error.message)
          : this.setZipcodeError(productServiceResponse.error.message);
        return;
      }
      this.setCookies(config.flatgas.cookieName);
      this.showPrice = true;
      this.product = productServiceResponse;
      this.setFlatGasPricing(productServiceResponse);
    },
    handleZipcodeFocus() {
      this.zipcodeHasError = false;
      this.zipcodeFocused = true;
    },
    handleZipcodeBlur() {
      this.zipcodeFocused = false;
    },
    handleConsumptionFocus() {
      this.consumptionHasError = false;
    },
    reset() {
      this.zipcodeHasError = false;
      this.consumptionHasError = false;
      this.showPrice = false;
      this.showInfo=false;
    },
    async getProducts() {
      return await getProductsService({
        zipcode: this.zipcode,
        consumption: this.consumption,
        itemId: config.flatgas.itemId,
        division: config.flatgas.division
      });
    },

    async validate() {
      let invalid = false;
      if (!/[0-9]$/.test(this.consumption)) {
        this.setConsumptionError(config.flatgas.error.consumptionInvalidFormat);
        invalid = true;
      }

      if (!/^[0-9]{5}$/.test(this.zipcode)) {
        this.setZipcodeError(config.flatgas.error.zipcodInvalidFormat);
        invalid = true;
      }

      if (invalid) {
        return false;
      }
      const validationResult = await this.validateZipCodeApi();      
      if (validationResult.exception) {
        this.showInfo =
          validationResult.exception.code == config.flatgas.code.zipcodeNotAvailableHint ||
          validationResult.exception.code == config.flatgas.code.zipcodeOutOfRangeHint;
        this.setZipcodeError(
          validationResult.exception.message
            .replace("{zipcode}", this.zipcode)
            .replace("{consumption}", this.consumption)
        );
        return false;
      }
      return true;
    },
    async validateZipCodeApi() {
      const data = {
        zipcode: this.zipcode,
        division: config.flatgas.division,
        unit: config.flatgas.unit,
        consumption: this.consumption
      };

      const result = await validateZipcodeService(data);
      return result.data.xmlResponse;
    },

    setZipcodeError(msg) {
      this.zipcodeErrorMsg = msg;
      this.zipcodeHasError = true;
    },
    setConsumptionError(msg) {
      this.consumptionErrorMsg = msg;
      this.consumptionHasError = true;
    },
    setCookies(name) {
      let cookieObj = this.getCookies(name) || {};
      cookieObj.zipcode = this.zipcode;
      cookieObj.consumption = this.consumption;
      this.$cookies.set(name, cookieObj);
    },
    getCookies(key) {
      return this.$cookies.get(key);
    },
    setFlatGasPricing(obj) {
      $("#totalCost").html(obj.totalCost);
      $("#salesCompany").html(obj.salesCompany);
      $("#validFrom").html(obj.validFrom);
      $(".column--left").prepend($("#flatGasPricing"));
      $("#flatGasPricing").show();
    }
  }
};
</script>



